import * as ACTION_TYPES from './types';
import { CONTEXT_MENU_CHANGE_TYPE } from '../contextMenu/types';

const initialState = {
  status: {
    loading: -1,
  },
  ids: [],
  meta: {
    pagination: {
      page: 1,
      pages: 1,
    },
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.CONSULT_HISTORY_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.CONSULT_HISTORY_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        ids: [...state.ids, ...payload.result.data],
        meta: payload.result.meta,
      };
    case ACTION_TYPES.CONSULT_HISTORY_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };
    case CONTEXT_MENU_CHANGE_TYPE:
      return initialState;
    default:
      return state;
  }
}
